<template>
    <b-container fluid class="supplement-prompt-management">
        <admin-page-header title="AI 판단 기준 관리"
                           description="보완검토에서 남긴 피드백을 AI 의 판단 기준에 반영합니다. 반영한 내용은 버전으로 저장되며, 적용하면 약 1분 내에 이후 판정부터 반영됩니다."/>

        <b-card no-body>
            <b-tabs v-model="tabIndex" card>
                <b-tab title="피드백 인박스" lazy>
                    <FeedbackInboxTab />
                </b-tab>
                <b-tab title="버전 이력" lazy>
                    <AssetVersionsTab @check-gate="tabIndex = 2" />
                </b-tab>
                <b-tab title="수렴 지표" lazy>
                    <MetricsTab />
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
import FeedbackInboxTab from './FeedbackInboxTab.vue';
import AssetVersionsTab from './AssetVersionsTab.vue';
import MetricsTab from './MetricsTab.vue';
import {firstQueryValue} from './prompt-labels';

// URL ?tab=<key> ↔ 탭 위치. 모르는 값은 첫 탭, 첫 탭(피드백 인박스)은 URL 에서 생략한다.
const TAB_KEYS = ['inbox', 'versions', 'metrics'];

function tabIndexOf(query) {
    return Math.max(0, TAB_KEYS.indexOf(firstQueryValue(query && query.tab)));
}

export default {
    name: 'SupplementPromptManagement',
    components: {FeedbackInboxTab, AssetVersionsTab, MetricsTab},
    data() {
        return {
            tabIndex: tabIndexOf(this.$route.query),
        };
    },
    watch: {
        // 탭을 바꾸면 다른 탭의 조건(status·asset_type 등)은 버린다 — lazy 탭이라 화면도 새로 시작한다.
        tabIndex(index) {
            if (tabIndexOf(this.$route.query) === index) return;
            this.$router.push({query: index > 0 ? {tab: TAB_KEYS[index]} : {}}).catch(() => {});
        },
        // 뒤로가기·사이드바 재클릭으로 같은 화면의 URL 이 바뀌면 탭을 맞춘다.
        '$route.query.tab'() {
            this.tabIndex = tabIndexOf(this.$route.query);
        },
    },
};
</script>

<style scoped>
.supplement-prompt-management h4 {
    font-weight: 700;
}
</style>
